import type { ISODate, PeriodType, SuretyAccountId } from "@inrev/common";
import type { FC } from "react";
import { BlocSizeModal } from "./BlocSizeModal";
import { FinancialStatementUploadModal } from "./FinancialStatementUploadModal";
import { ProfitabilityModal } from "./ProfitabilityModal";
import type { ProfitabilityField } from "./types";

export type ActionItemModalState =
	| null
	| { kind: "upload"; periodEndDate: ISODate; periodType: PeriodType }
	| { kind: "profitability"; fields: readonly ProfitabilityField[] }
	| { kind: "blocSize"; fyeDate: ISODate };

type ActionItemModalsProps = {
	accountId: SuretyAccountId;
	state: ActionItemModalState;
	onClose: () => void;
};

export const ActionItemModals: FC<ActionItemModalsProps> = ({ accountId, state, onClose }) => {
	if (state === null) {
		return null;
	}

	if (state.kind === "upload") {
		return (
			<FinancialStatementUploadModal
				accountId={accountId}
				periodEndDate={state.periodEndDate}
				periodType={state.periodType}
				onClose={onClose}
			/>
		);
	}

	if (state.kind === "profitability") {
		return <ProfitabilityModal accountId={accountId} fields={state.fields} onClose={onClose} />;
	}

	return <BlocSizeModal accountId={accountId} fyeDate={state.fyeDate} onClose={onClose} />;
};
